<div class="page-container">
  <div class="my-profile__common-info">
    <div class="sub-title">PROFILE SETTINGS</div>
    <div class="o-flex o-flex--justify-space-between o-flex--align-items-center">
      <span class="general-info--font-size-35 line-height-40">My Profile</span>
    </div>
  </div>
  <div class="o-flex o-flex--justify-center o-flex--wrap u-margin-top-20 my-profile__item-container">
    <ng-container *ngFor="let profileItem of profileItemList">
      <app-profile-item *ngIf="profileItem.isVisible" class="my-profile__item u-cursor-pointer u-display-inline-block u-margin-right-10 u-margin-bottom-20" [config]="profileItem"></app-profile-item>
    </ng-container>
  </div>
</div>
